import EmergoRequest from '../models/emergo'
import axios from '@/app/axios'
import Responses from '@/app/utils/responses'

class EmergoService {
  public async sendAsync(entity: EmergoRequest) {
    const res = await axios.post<EmergoRequest>('emergo', entity)
    return Responses.obj(res) as EmergoRequest
  }
}

export default new EmergoService()
